const crypto= require('crypto');
	
class Globant {
    /**
     * @param config {Object} in the format { globantKey: String, globantAlgorithm: String, globantIV: String }
     */
	constructor(config) {
		this.config = config;
	}

	encryptGlobant(text) {
		if(!text){
			throw new Error(`Text param is needed to create Globant encrypted token`);
		}

		const { globantAlgorithm, globantIV, globantKey } = this.config;
		if(!globantAlgorithm){
			throw new Error(`Algorithm 'globantAlgorithm' required to create Globant encrypted token`);
		}
		if(!globantKey){
			throw new Error(`Key 'globantKey' required to create Globant encrypted token`);
		}
		if(!globantIV){
			throw new Error(`Initialization vector 'globantIV' required to create Globant encrypted token`);
		}

		const key = crypto.createHash('md5').update(globantKey, 'utf18').digest();
		const iv = new Buffer(globantIV, 'base64');
		const encrypted = new Buffer(text, 'ascii');

		let cipher = crypto.createCipheriv(globantAlgorithm, key, iv);
		let encoded = cipher.update(encrypted, 'binary', 'base64');
		encoded += cipher.final('base64');

		let cipher2 = crypto.createCipheriv(globantAlgorithm, key, iv);
		let encoded2 = cipher2.update(encoded, 'ascii', 'base64');
		encoded2 += cipher2.final('base64');

		return encoded2;
	}

	/**
	  * Decrypts a Globant Encrypted String
	  * @param {String}
	  * @return {String}
	  */
	decryptGlobant(text) {
		if(!text){
			throw new Error(`Globant encrypted text param is required to perform decrypt`);
		}

		let encryptionKey = this.config.globantKey;
		let alg = this.config.globantAlgorithm;

		let encryptedKey = crypto.createHash('md5').update(encryptionKey, 'utf18').digest();
		let iv = new Buffer(this.config.globantIV, 'base64');
		let encrypted = new Buffer(text, 'base64');

		let decipher = crypto.createDecipheriv(alg, encryptedKey, iv);
		let decoded = decipher.update(encrypted, 'binary', 'ascii');
		decoded += decipher.final('ascii');

		encrypted = new Buffer(decoded.toString('base64'), 'base64');

		let decipher2 = crypto.createDecipheriv(alg, encryptedKey, iv);
		let decoded2 = decipher2.update(encrypted, 'binary', 'ascii');
		decoded2 += decipher2.final('ascii');

		return decoded2;
	}
}

export default Globant